import { cn } from 'utils/cn'

import type { FC } from 'react'

type Props = {
  size: 'sm' | 'md' | 'xl'
}

export const SkeletonPlaceholder: FC<Props> = ({ size }) => (
  <div
    className={cn('bg-subdued-transparent animate-pulse rounded h-4', {
      'w-11/12': size === 'md',
      'w-14': size === 'sm',
      'w-full': size === 'xl',
    })}
  />
)
